import { render, staticRenderFns } from "./banjiall.vue?vue&type=template&id=717df2d0&scoped=true&"
import script from "./banjiall?vue&type=script&lang=js&"
export * from "./banjiall?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717df2d0",
  null
  
)

export default component.exports